import React from 'react';
import { useContactImageModule } from '../hooks/useContactImageModule';
import { getBestImageUrl } from '../utils/imageUrl';
import contactFallback from '../assets/images/contact.png';

interface ContactImageModuleProps {
  className?: string;
  showOverlay?: boolean;
}

export function ContactImageModule({ className, showOverlay = false }: ContactImageModuleProps): React.JSX.Element | null {
  const { data: imageData, loading, error } = useContactImageModule();

  if (loading) {
    return (
      <div className="contact-image-module-loading">
        Laden...
      </div>
    );
  }

  if (error || !imageData) {
    return (
      <section className={`contact-image-module-section${className ? ` ${className}` : ''}`}>
        <img src={contactFallback} alt="Contact" />
      </section>
    );
  }

  const imageUrl = imageData.imageUrl || getBestImageUrl(imageData.image as any);
  if (!imageUrl) {
    return (
      <section className={`contact-image-module-section${className ? ` ${className}` : ''}`}>
        <img src={contactFallback} alt={imageData.altText || 'Contact'} />
      </section>
    );
  }

  return (
    <section className={`contact-image-module-section${className ? ` ${className}` : ''}`}>
      <img
        src={imageUrl}
        alt={imageData.altText || imageData.image?.alternativeText || 'Contact image'}
      />
      {showOverlay && (imageData.title || imageData.description) && (
        <div className="image-overlay">
          {imageData.title && (
            <h2 className="image-title">
              {imageData.title}
            </h2>
          )}
          {imageData.description && (
            <p className="image-description">
              {imageData.description}
            </p>
          )}
        </div>
      )}
    </section>
  );
} 